import { capitalize, uniqBy } from '@guiker/lodash'

const capitalizeStreetName = (street: string) => {
  return street
    .split(' ')
    .map((segment) => capitalize(segment))
    .join(' ')
}

const compareUniqueStrings = (compareString: string, strings: string[]) => {
  return uniqBy(strings, (s) => s.toLowerCase()).filter((v) => v.toLowerCase() !== compareString.toLowerCase())
}

const extractStreetName = (streetName: string, streetNumber: string) => {
  return streetName.replace(streetNumber, '').trim()
}

export { extractStreetName, compareUniqueStrings, capitalizeStreetName }
